/*
 * usersMe Reducer
 */
import { RESET_STATE } from '../auth/constants';
import { USERS_ME_SET } from './constants';

const initialState = {};

export default function(state = initialState, action) {
    switch (action.type) {
        case USERS_ME_SET:
            return {
                ...action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
